(function () {
    'use strict';
    app.service('userAccountService', ['$http', '$q', '$rootScope',
    function ($http, $q, $rootScope) {


        var serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;
        var deferred;

        this.getAccountData = function (username) {
            deferred = $q.defer();

            $http.get(serviceBase + "api/Account/user?username=" + username)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.deleteRecords = function (userInfo) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/Account/deleteRecords", userInfo, {
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err, status) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }

        this.cancelSubscription = function () {
            deferred = $q.defer();

            $http.post(serviceBase + "api/Account/cancelSubscription")
                .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err, status) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }

    }
    ]);
})();